var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.allowplanner == 1
    ? _c("div", { staticClass: "outer", attrs: { id: this.message } }, [
        _vm.inSelected == 1
          ? _c("div", { staticClass: "blockelouter" }, [
              _c(
                "div",
                {
                  staticClass: "blockel",
                  on: { click: _vm.removeFromSelected }
                },
                [
                  _c("img", { attrs: { src: this.imgsrc } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: _vm.setVisible },
                    [
                      _c("button", [
                        _c("span", [_vm._v(_vm._s(_vm.addMessage))])
                      ]),
                      _vm._v(" "),
                      _c("ejs-datepicker", {
                        ref: "dateObj",
                        attrs: {
                          id: "date",
                          placeholder: "Select Date",
                          change: _vm.onChange,
                          open: _vm.onOpen,
                          focus: _vm.onFocus,
                          value: _vm.dateval
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "calnotice",
                domProps: { innerHTML: _vm._s(_vm.notice) }
              })
            ])
          : _c("div", { staticClass: "blockelouter" }, [
              _c(
                "div",
                { staticClass: "blockel", on: { click: _vm.onFocus } },
                [
                  _c("img", { attrs: { src: this.imgsrc } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: _vm.setVisible },
                    [
                      _c("button", [
                        _c("span", [_vm._v(_vm._s(_vm.addMessage))])
                      ]),
                      _vm._v(" "),
                      _c("ejs-datepicker", {
                        ref: "dateObj",
                        attrs: {
                          id: "date",
                          placeholder: "Select Date",
                          change: _vm.onChange,
                          open: _vm.onOpen,
                          focus: _vm.onFocus,
                          value: _vm.dateval
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "calnotice",
                domProps: { innerHTML: _vm._s(_vm.notice) }
              })
            ])
      ])
    : _c("div", { staticClass: "outer", attrs: { id: this.message } }, [
        _c("div", { staticClass: "blockel", on: { click: _vm.onFocus } }, [
          _c("img", { attrs: { src: this.imgsrc } }),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "itemcontrols",
        attrs: { href: "/my-account/virtual-assistant/" }
      },
      [
        _c("span", { staticClass: "spanbtn" }, [
          _vm._v("Please confirm your settings.")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/erikoberhausen/Documents/upperhouse/sukle/awkwardagent/awkward/web/app/themes/sage/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/erikoberhausen/Documents/upperhouse/sukle/awkwardagent/awkward/web/app/themes/sage/node_modules/vue-loader/lib?{}!./scripts/Addtoplannergs.vue?vue&type=template&id=7ae493ed&
// module id = 622
// module chunks = 4